export default {
  // 运营位置的tag
  GOLD_EMPLACEMENT: 'myyc_gold',
  // 金刚位
  HOT_SHOP_LIST: 'myyc_hotshop' // 热门场馆

};